import { TextField } from "../StyledComponents";
import SoftBox from "components/SoftBox";
import { styles } from "../..";
import { useDebouncer } from "hooks/useDebouncer";
import { ComponentPropsContextApi } from "layouts/Flow Designer/context";
import { useContext, useState } from "react";
import { ComponentPropsContext } from "layouts/Flow Designer/context";
import { combineStyles } from "helpers/common";

const safeParseInt = (val) => {
  if (typeof val === "number" && Number.isInteger(val)) return val;
  if (typeof val === "string" && /^[+-]?\d+$/.test(val)) return parseInt(val, 10);
  return null;
};

export const NumberInput = ({ action, fieldValue, allowEditWorkflow }) => {
  const { actionForm } = useContext(ComponentPropsContext);
  const { setActionForm } = useContext(ComponentPropsContextApi);
  const { debouncer: inputDebouncer } = useDebouncer(handleFormInputChange);
  const [value, setValue] = useState(fieldValue);

  const handleSetValue = (event) => {
    const parsedValue = safeParseInt(event.target.value);

    if (parsedValue !== null) {
      const minimum = action.min ?? 0;
      const boundedValue = Math.min(Math.max(parsedValue, minimum), action.max ?? Number.MAX_SAFE_INTEGER);

      setValue(boundedValue);
      inputDebouncer(event);
    }
  };

  function handleFormInputChange(e) {
    const { name } = e.target;
    let actionFormCopy = { ...actionForm };

    if (actionFormCopy[name]?.isPassword) {
      actionFormCopy[name] = {
        ...actionFormCopy[name],
        value,
        isPassword: true,
        isEncoded: false
      };
    }

    setActionForm({
      ...actionFormCopy,
      [name]: { ...actionFormCopy[name], value, isVariable: false }
    });
  }

  return (
    <SoftBox
      display="flex"
      flexDirection="column"
      width="100%"
      sx={combineStyles(styles.w100, styles.listItemMargin_t16)}
    >
      <TextField
        value={value}
        type={action.type}
        placeholder={action.placeholder || ""}
        label={action.label}
        slotProps={{
          htmlInput: {
            min: action.min ?? 0,
            max: action.max
          }
        }}
        disabled={!allowEditWorkflow}
        name={action.field}
        onChange={handleSetValue}
      />
    </SoftBox>
  );
};
